import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CustomerListComponent} from './customer-list/customer-list.component';


export const customerRoutes: Routes = [
  {
    path: 'customer',
    data: {
      'expectedRoles': ['Accountant']
    },
    children: [
      {
        path: 'list',
        component: CustomerListComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(customerRoutes)],
  exports: [RouterModule]
})
export class CustomerRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-routing.module.ts